import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { listTypeVehicles } from 'src/models/veiculo.model';
import { UntypedFormGroup } from '@angular/forms';
import { TypeVehicle } from '../../../models/veiculo.model';
import { register } from 'swiper/element/bundle';
import { IonicSlides } from '@ionic/angular';

register();
@Component({
    selector: 'app-carrousel-cars',
    templateUrl: './carrousel-cars.component.html',
    styleUrls: ['./carrousel-cars.component.scss'],
    standalone: false
})
export class CarrouselCarsComponent implements OnInit {

  constructor() { }

  listCars = listTypeVehicles;
  selectedItem: number = TypeVehicle.MiniVan;
  @Input() controlForm: UntypedFormGroup;
  @Output() carTypeChanged = new EventEmitter();

  public swiperModules = [IonicSlides];

  ngOnInit() {
  }

  selectCar(index, item) {

    this.selectedItem = index;
    this.controlForm.setValue(item.value);
    this.carTypeChanged.emit(item.value);

  }

}
